export const licences = [
  { id: "0", title: "Offline Games", value: 0 },
  // { id: "1", title: "Increase Max. Speed", value: 1 },
  { id: "2", title: "Diagnostic Suite", value: 2 },
  { id: "3", title: "Region", value: 3 }
];

//This value are in seconds
export const expirationDates = [
  { id: "0", title: "1/month", value: 2678400 },
  { id: "1", title: "2/month", value: 5356800 },
  { id: "2", title: "3/month", value: 8035200 },
  { id: "3", title: "6/month", value: 16070400 },
  { id: "4", title: "12/months", value: 32140800 },
  { id: "5", title: "24/months", value: 64281600 },
  { id: "6", title: "Never", value: -1 },
];

export const speedParamateres = [
  { id: "0", title: "60", value: 60 },
  { id: "1", title: "80", value: 80 },
  { id: "2", title: "100", value: 100 },
];

export const regionParameters = [
  { id: "0", title: "International", value: 'international' },
  { id: "1", title: "China", value: "china" },
];

// prettier-ignore
export const arrayOfBytes = new Uint8Array([
  0xb2,0x4d,0xb9,0xe5,0x63,0x3b,0xc9,0x35,
  0x57,0x65,0xee,0xe7,0x85,0xfd,0x78,0xb6,
  0x4c,0x4b,0xdf,0x59,0x7e,0x7d,0xe5,0x10,
  0xc4,0x31,0xfc,0xa9,0x4f,0x18,0xbd,0x71,
  0x2a,0x4a,0xb5,0x52,0xff,0x3b,0xc9,0x85,
  0xd9,0x89,0x70,0x09,0xa7,0xb3,0xdf,0xe4,
  0x83,0x14,0xa1,0xc9,0xf1,0xaf,0x78,0xe5,
  0x25,0xcc,0x5c,0x43,0x4a,0x69,0xdb,0x6a,
]);
